import React from "react";
import "./loading.scss";

/**
 * Penanda proses muat untuk seluruh halaman.
 *
 * Dipakai penjaga rute di App.js selama profil server belum dipastikan, jadi
 * ini yang terlihat pengguna setiap kali halaman di-reload.
 *
 * Sebelumnya komponen ini menampilkan logo Mamboo, dan satu-satunya gayanya
 * ada di App.scss — berkas yang tidak diimpor dari mana pun. Akibatnya logonya
 * muncul mentah di sudut kiri atas tanpa pemusatan. Gaya spinner ini diimpor
 * langsung dari komponennya supaya hal yang sama tidak terulang.
 */
const Loading = () => {
  return (
    <div className="app-loading" role="status">
      <span className="app-loading-spinner" aria-hidden="true" />
      {/* Disembunyikan secara visual, tapi tetap dibacakan pembaca layar —
          spinner sendiri tidak menyampaikan apa pun tanpa teks. */}
      <span className="app-loading-label">Memuat…</span>
    </div>
  );
};

export default Loading;
